import { Fragment } from 'react';

import { Container, Part, PartLink, PartDivider } from './styledComponents';

export type BreadcrumbProps = {
  className?: string;
  parts?: Array<{ label: string; to: string }>;
  currentLabel: string;
};
export const Breadcrumb: React.FC<BreadcrumbProps> = (props) => {
  const { parts, currentLabel, className = '' } = props;
  return (
    <Container className={className}>
      {parts?.map((d) => {
        const { label, to } = d;
        return (
          <Fragment key={label}>
            <Part>
              <PartLink to={to}>{label}</PartLink>
            </Part>
            <PartDivider>{'>'}</PartDivider>
          </Fragment>
        );
      })}
      <Part>{currentLabel}</Part>
    </Container>
  );
};
